import { HOSPITAL_ROUTE } from '@/router/hospital.routes';
import UiTableWithPagination from '@/components/ui/UiTableWithPagination/index.vue';
import HospitalStatusTag from '@/components/hospitals/HospitalStatusTag/index.vue';
import { MiIcon } from '~shared/ui';

export default {
  name: 'HospitalsTable',
  emits: ['update:page', 'update:perPage', 'sort-change'],
  components: { UiTableWithPagination, HospitalStatusTag, MiIcon },
  props: {
    /** @type Array<Hospital> data */
    data: Array,
    total: Number,
    loading: Boolean,
    page: Number,
    perPage: Number,
    columns: Object,
    defaultSort: Object,
  },

  methods: {
    goToHospital(hospital) {
      this.$router.push({
        name: HOSPITAL_ROUTE.name,
        params: { id: hospital.id },
      });
    },

    onSortChange({ prop, order }) {
      this.$emit('sort-change', { prop, order });
    },
  },
};
